export const MersDeactivationDetailsFormTestIds = {
  FORM: 'mers-deactivation-details.form',
  LIQUIDATION_DATE: 'mers-deactivation-details.liquidation-date',
  SUBMIT_BUTTON: 'mers-deactivation-details.submit-button',
};
